import React, { useEffect, createElement } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { SystemTypesPage } from './pages/SystemTypesPage';
import { InstallationPage } from './pages/InstallationPage';
import { ConcreteFinishesPage } from './pages/ConcreteFinishesPage';
import { MaterialsPage } from './pages/MaterialsPage';
export function App() {
  useEffect(() => {
    // Google Tag Manager - head script
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-TCX7239C');`;
    document.head.insertBefore(script, document.head.firstChild);
    // Google Tag Manager - noscript (body)
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-TCX7239C';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <HashRouter data-id="element-0">
      <div className="min-h-screen bg-background font-sans antialiased" data-id="element-1">
        <Header data-id="element-2" />
        <main data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/system-types" element={<SystemTypesPage data-id="element-8" />} data-id="element-7" />
            <Route path="/installation-process" element={<InstallationPage data-id="element-10" />} data-id="element-9" />
            <Route path="/concrete-finishes" element={<ConcreteFinishesPage data-id="element-12" />} data-id="element-11" />
            <Route path="/materials" element={<MaterialsPage data-id="element-14" />} data-id="element-13" />
          </Routes>
        </main>
        <Footer data-id="element-15" />
      </div>
    </HashRouter>;
}